import { useContextSelector } from 'use-context-selector';
import { UserStateContext } from '../context/UserContext/UserContext';

export const useReportById = (id: string) => {
  return useContextSelector(UserStateContext, (v) =>
    v?.state.reports.find((report) => report.id === id)
  );
};
